var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.895 27.891",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 61"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 48"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 47"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 82",
    d: "M22.758 19.747h-3.5v-1.153h3.5a4.049 4.049 0 0 0 .484-8.07.6.6 0 0 1-.521-.6 4.092 4.092 0 0 0-3.57-4.054.594.594 0 0 1-.521-.558v-.074a4.054 4.054 0 0 0-8.107 0 .587.587 0 0 1-.6.6h-.6A4.063 4.063 0 0 0 5.27 9.892a.64.64 0 0 1-.521.632 4.049 4.049 0 0 0 .484 8.07h3.5v1.153h-3.5A5.232 5.232 0 0 1 4.08 9.409a5.248 5.248 0 0 1 5.206-4.76h.037a5.234 5.234 0 0 1 10.413.112 5.18 5.18 0 0 1 4.053 4.649 5.254 5.254 0 0 1 4.091 5.095 5.075 5.075 0 0 1-5.122 5.242Z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 49"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 83",
    d: "M8.256 9.892H7.103a2.9 2.9 0 0 1 2.9-2.9v1.153a1.746 1.746 0 0 0-1.747 1.747Z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 60"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 53"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 51"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 50"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 84",
    d: "M16.962 19.747v-6.731l-1.413-1.376h-4.388v8.144a1.159 1.159 0 0 1-1.153-1.153V11.64a1.159 1.159 0 0 1 1.153-1.153h4.648a.6.6 0 0 1 .409.186l1.744 1.748a.6.6 0 0 1 .186.409v5.8a1.212 1.212 0 0 1-1.186 1.117Z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 52"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 85",
    d: "M17.553 13.351h-1.748a.587.587 0 0 1-.595-.6v-1.743h1.153v1.153h1.153v1.19Z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 54"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 86",
    d: "M8.814 24.99H7.661v-2.305a1.133 1.133 0 0 1 1.153-1.157h4.648v-4.087h1.157v4.054a1.133 1.133 0 0 1-1.153 1.153H8.818Z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 55"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 87",
    d: "M20.454 24.991h-1.19v-2.306h-3.5v-1.153h3.5a1.133 1.133 0 0 1 1.153 1.153v2.306Z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 56"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 88",
    d: "M8.256 27.891a1.748 1.748 0 1 1 1.748-1.748 1.746 1.746 0 0 1-1.748 1.748Zm0-2.343a.6.6 0 1 0 .6.6.612.612 0 0 0-.6-.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 57"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 89",
    d: "M14.057 27.891a1.748 1.748 0 1 1 1.748-1.748 1.746 1.746 0 0 1-1.748 1.748Zm0-2.343a.6.6 0 1 0 .595.6.587.587 0 0 0-.595-.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 58"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 90",
    d: "M19.859 27.891a1.748 1.748 0 1 1 1.748-1.748 1.746 1.746 0 0 1-1.748 1.748Zm0-2.343a.6.6 0 1 0 .595.6.587.587 0 0 0-.595-.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 59"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Ret\\xE2ngulo 24",
    d: "M13.462 23.242h1.153v1.748h-1.153z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGedIcon);
export default __webpack_public_path__ + "static/media/ged-icon.7d7c1a35cb9193f12e5d13018a1856d0.svg";
export { ForwardRef as ReactComponent };